import _times from "lodash/times";
import React from 'react';
import PropTypes from 'prop-types';
import SkeletonLoading from '@nerdwallet/react-skeleton-loading';
import styles from "./skeleton-keto-product-card.module.css";
var SkeletonKetoProductCard = function SkeletonKetoProductCard(_ref) {
  var className = _ref.className,
    _ref$driverAmount = _ref.driverAmount,
    driverAmount = _ref$driverAmount === void 0 ? 4 : _ref$driverAmount,
    largeDriver = _ref.largeDriver;
  return /*#__PURE__*/React.createElement(SkeletonLoading, {
    className: className
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.header
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.body
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.imageRatingContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.imageCtaContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.image
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.cta
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.ratingContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.rating
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.ratingLink
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles.driversContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.driversLabelsContainer
  }, _times(driverAmount, function () {
    return /*#__PURE__*/React.createElement("div", {
      className: largeDriver ? styles.largeDriver : styles.driver
    });
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.driversContentContainer
  }, _times(driverAmount, function () {
    return /*#__PURE__*/React.createElement("div", {
      className: largeDriver ? styles.largeDriver : styles.driver
    });
  })))), /*#__PURE__*/React.createElement("div", {
    className: styles.accordionContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.accordion
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.accordion
  }))));
};
SkeletonKetoProductCard.propTypes = {
  className: PropTypes.string,
  driverAmount: PropTypes.number,
  largeDriver: PropTypes.bool
};
SkeletonKetoProductCard.displayName = 'SkeletonKetoProductCard';
export default SkeletonKetoProductCard;